/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CorrectionUpsertRequest
 */
export interface CorrectionUpsertRequest {
    /**
     * 
     */
    submissionId: string;
    /**
     * 
     */
    lengthMm?: number | null;
    /**
     * 
     */
    girthMm?: number | null;
    /**
     * 
     */
    weightG?: number | null;
    /**
     * 
     */
    species?: string | null;
    /**
     * 
     */
    note?: string | null;
}

/**
 * Check if a given object implements the CorrectionUpsertRequest interface.
 */
export function instanceOfCorrectionUpsertRequest(value: object): value is CorrectionUpsertRequest {
    if ((!('submissionId' in (value as Record<string, any>)) && !('submission_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['submissionId'] === undefined && (value as Record<string, any>)['submission_id'] === undefined)) return false;
    return true;
}

export function CorrectionUpsertRequestFromJSON(json: any): CorrectionUpsertRequest {
    return CorrectionUpsertRequestFromJSONTyped(json, false);
}

export function CorrectionUpsertRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrectionUpsertRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'submissionId': json['submission_id'],
        'lengthMm': json['length_mm'] === undefined ? undefined : json['length_mm'] === null ? null : json['length_mm'],
        'girthMm': json['girth_mm'] === undefined ? undefined : json['girth_mm'] === null ? null : json['girth_mm'],
        'weightG': json['weight_g'] === undefined ? undefined : json['weight_g'] === null ? null : json['weight_g'],
        'species': json['species'] === undefined ? undefined : json['species'] === null ? null : json['species'],
        'note': json['note'] === undefined ? undefined : json['note'] === null ? null : json['note'],
    };
}

export function CorrectionUpsertRequestToJSON(json: any): CorrectionUpsertRequest {
    return CorrectionUpsertRequestToJSONTyped(json, false);
}

export function CorrectionUpsertRequestToJSONTyped(value?: CorrectionUpsertRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submission_id': value['submissionId'],
        'length_mm': value['lengthMm'],
        'girth_mm': value['girthMm'],
        'weight_g': value['weightG'],
        'species': value['species'],
        'note': value['note'],
    };
}

